export default "__VITE_ASSET__DWz0stke__"